//browserslist query "> 0.1%, not dead"
export const PrefixCSS: Record<string, string[]> = {
  transform: ["webkit", "ms"],
  transition: ["webkit", "ms"],
  animation: ["webkit"],
  userSelect: ["webkit", "ms"],
  flexDirection: ["webkit", "ms"],
  flexWrap: ["webkit", "ms"],
  justifyContent: ["webkit", "ms"],
  alignItems: ["webkit", "ms"],
  alignSelf: ["webkit", "ms"],
  order: ["webkit", "ms"],
  flexGrow: ["webkit", "ms"],
  flexShrink: ["webkit", "ms"],
  flexBasis: ["webkit", "ms"],
  columns: ["webkit"],
  columnCount: ["webkit"],
  columnGap: ["webkit"],
  columnRule: ["webkit"],
  columnWidth: ["webkit"],
  boxSizing: ["webkit"],
  appearance: ["webkit", "moz"],
  filter: ["webkit"],
  backdropFilter: ["webkit"],
  clipPath: ["webkit"],
  mask: ["webkit"],
  maskImage: ["webkit"],
  textSizeAdjust: ["webkit", "ms"],
  hyphens: ["webkit", "ms"],
  writingMode: ["webkit", "ms"],
  gridTemplateColumns: ["ms"],
  gridTemplateRows: ["ms"],
  gridAutoColumns: ["ms"],
  gridAutoRows: ["ms"],
  gridColumn: ["ms"],
  gridRow: ["ms"],
  marginInlineStart: ["webkit"],
  marginInlineEnd: ["webkit"],
  paddingInlineStart: ["webkit"],
  paddingInlineEnd: ["webkit"],
  minInlineSize: ["webkit"],
  maxInlineSize: ["webkit"],
  minBlockSize: ["webkit"],
  maxBlockSize: ["webkit"],
  inlineSize: ["webkit"],
  blockSize: ["webkit"],
  tabSize: ["moz"],
  overscrollBehavior: ["webkit", "ms"],
  touchAction: ["ms"],
  resize: ["webkit"],
  printColorAdjust: ["webkit"],
  backgroundClip: ["webkit"],
  boxDecorationBreak: ["webkit"],
  overflowScrolling: ["webkit"],
};
